var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useLocale } from '../../communication';
import { t } from '@mp/locale';
import { getCurrencySymbol } from "../utils";
import Help from "../Help/Help";
import FinePrint from './FinePrintReview';
export default function TotalReview(_a) {
    var _b;
    var handleTracking = _a.handleTracking, order = _a.order, suppressTotal = _a.suppressTotal;
    var isContract = (order === null || order === void 0 ? void 0 : order.pricing_type) === 'Contract';
    var language = useLocale().language;
    return (_jsxs("div", __assign({ className: "mp-capturesvc-review-total" }, { children: [!suppressTotal && (_jsxs(_Fragment, { children: [_jsxs("div", __assign({ className: "review-total-label" }, { children: [t("CAPTURE_SERVICES.ORDER.REVIEW.totalDueNow"), _jsx(Help, __assign({ icon: "ico-info-sign", role: "button" }, { children: t("CAPTURE_SERVICES.ORDER.REVIEW.".concat(isContract ? 'CONTRACT.' : "", "tooltip")) }))] })), _jsxs("div", __assign({ className: "review-total-value", "ng-if": "!loading.status" }, { children: [getCurrencySymbol(order === null || order === void 0 ? void 0 : order.estimate_currency), (_b = order === null || order === void 0 ? void 0 : order.estimate_price) === null || _b === void 0 ? void 0 : _b.toLocaleString(language, { minimumFractionDigits: 2 })] }))] })), _jsx("div", __assign({ className: "review-total-description review-total-description-header" }, { children: t("CAPTURE_SERVICES.ORDER.REVIEW.descriptionHeader") })), _jsx(FinePrint, { isContract: isContract, handleTracking: handleTracking })] })));
}
